import { render } from "./LogisticsDefaultSuggestions.vue?vue&type=template&id=2209b78b"
import script from "./LogisticsDefaultSuggestions.vue?vue&type=script&lang=js"
export * from "./LogisticsDefaultSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__